import script from "./GodApeQuestInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestInfo.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestInfo.vue?vue&type=style&index=0&id=30edf40f&lang=scss"

const __exports__ = script;

export default __exports__